import { IColumnsGrouping } from "../../../components/table-grouping/TableGrouping";
import { GENDER_VARIABLE } from "../../../constants/moduleConsts";

export const columnSalaryRaiseTab1: IColumnsGrouping[] = [
  {
    name: "STT",
    field: "stt",
    render: (row, index, stt) => <span>{stt}</span>,
  },
  {
    name: "Họ và tên",
    field: "fullName",
    headerStyle: {
      minWidth: "150px"
    },
    cellStyle: {
      textAlign: "left"
    },
  },
  {
    name: "Năm sinh",
    field: "",
    child: [
      {
        name: "Nam",
        field: "maleBirthdate",
        headerStyle: {
          minWidth: "100px"
        },
        render: (row: any) =>  <span>{row.gender === GENDER_VARIABLE.MALE ? (row.namSinh || "") : ""}</span>
      },
      {
        name: "Nữ",
        field: "femaleBirthdate",
        headerStyle: {
          minWidth: "100px"
        },
        render: (row: any) => <span>{row.gender === GENDER_VARIABLE.FEMALE ? (row.namSinh || "") : ""}</span>
      }
    ]
  },
  {
    name: "Khoa, phòng",
    field: "phongBanText",
    headerStyle: {
      minWidth: "150px"
    },
  },
  {
    name: "Tên ngạch, chức danh nghề nghiệp",
    field: "chucDanhText",
    headerStyle: {
      minWidth: "100px"
    },
  },
  {
    name: "Ngạch, bậc, hệ số lương trước khi nâng bậc",
    field: "",
    child: [
      {
        name: "Mã nghạch, mã số chức danh",
        field: "maChucDanh",
        headerStyle: {
          minWidth: "100px"
        },
      },
      {
        name: "Bậc lương hiện hưởng",
        field: "bacLuongHienHuong",
        headerStyle: {
          minWidth: "120px"
        },
      },
      {
        name: "Hệ số lương hiện hưởng",
        field: "heSoLuongHienHuong",
        headerStyle: {
          minWidth: "100px"
        },
      },
      {
        name: "Thời điểm xếp lương",
        field: "thoiDiemXepLuong",
        headerStyle: {
          minWidth: "100px"
        },
      },
    ]
  },
  {
    name: "Kết quả nâng bậc lương",
    field: "",
    child: [
      {
        name: "Mã ngạch, mã số chức danh",
        field: "maChucDanh",
        headerStyle: {
          minWidth: "100px"
        },
      },
      {
        name: "Bậc lương mới",
        field: "bacLuongMoi",
        headerStyle: {
          minWidth: "100px"
        },
      },
      {
        name: "Hệ số lương mới",
        field: "heSoLuongMoi",
        headerStyle: {
          minWidth: "100px"
        },
      },
      {
        name: "Thời gian xếp lương và tính nâng bậc lương lần sau",
        field: "thoiDiemXepLuongLanSau",
        headerStyle: {
          minWidth: "100px"
        },
      },
    ]
  },
  {
    name: "Ghi chú",
    field: "ghiChu",
    headerStyle: {
      minWidth: "100px"
    }
  }
];

export const columnSalaryRaiseTab2: IColumnsGrouping[] = [
  {
    name: "STT",
    field: "stt",
    render: (row, index, stt) => <span>{stt}</span>
  },
  {
    name: "Họ và tên",
    field: "fullName",
    headerStyle: {
      minWidth: "150px"
    },
    cellStyle: {
      textAlign: "left"
    },
  },
  {
    name: "Năm sinh",
    field: "",
    child: [
      {
        name: "Nam",
        field: "maleBirthdate",
        headerStyle: {
          minWidth: "100px"
        },
        render: (row: any) =>  <span>{row.gender === GENDER_VARIABLE.MALE ? (row.namSinh || "") : ""}</span>
      },
      {
        name: "Nữ",
        field: "femaleBirthdate",
        headerStyle: {
          minWidth: "100px"
        },
        render: (row: any) => <span>{row.gender === GENDER_VARIABLE.FEMALE ? (row.namSinh || "") : ""}</span>
      }
    ]
  },
  {
    name: "Khoa, phòng",
    field: "phongBanText",
    headerStyle: {
      minWidth: "100px"
    },
  },
  {
    name: "Tên chức danh nghề nghiệp",
    field: "chucDanhText",
    headerStyle: {
      minWidth: "100px"
    },
  },
  {
    name: "Chức danh nghề nghiệp, bậc, hệ số hiên đang hưởng",
    field: "",
    child: [
      {
        name: "Mã số chức danh nghề nghiệp",
        field: "maChucDanh",
        headerStyle: {
          minWidth: "100px"
        },
      },
      {
        name: "Bậc lương hiện hưởng",
        field: "bacLuongHienHuong",
        headerStyle: {
          minWidth: "100px"
        },
      },
      {
        name: "Hệ số lương ở bậc hiện giữ",
        field: "heSoLuongHienHuong",
        headerStyle: {
          minWidth: "100px"
        },
      },
      {
        name: "Thời điểm xếp lương",
        field: "thoiDiemXepLuong",
        headerStyle: {
          minWidth: "100px"
        },
      },
    ]
  },
  {
    name: "Chức danh nghề nghiệp, bậc, hệ số mới",
    field: "",
    child: [
      {
        name: "Mã số chức danh nghề nghiệp",
        field: "maChucDanh",
        headerStyle: {
          minWidth: "100px"
        },
      },
      {
        name: "Bậc lương mới",
        field: "bacLuongMoi",
        headerStyle: {
          minWidth: "100px"
        },
      },
      {
        name: "Hệ số lương mới",
        field: "heSoLuongMoi",
        headerStyle: {
          minWidth: "100px"
        },
      },
      {
        name: "Thời gian tính nâng bậc lương lần sau",
        field: "thoiDiemXepLuongLanSau",
        headerStyle: {
          minWidth: "100px"
        },
      },
    ]
  },
  {
    name: "Ghi chú",
    field: "ghiChu",
    headerStyle: {
      minWidth: "100px"
    }
  }
];

export const columnSalaryRaiseTab3: IColumnsGrouping[] = [
  {
    name: "STT",
    field: "stt",
    render: (row, index, stt) => <span>{stt}</span>
  },
  {
    name: "Họ và tên",
    field: "fullName",
    headerStyle: {
      minWidth: "150px"
    },
    cellStyle: {
      textAlign: "left"
    },
  },
  {
    name: "Năm sinh",
    field: "",
    child: [
      {
        name: "Nam",
        field: "maleBirthdate",
        headerStyle: {
          minWidth: "100px"
        },
        render: (row: any) =>  <span>{row.gender === GENDER_VARIABLE.MALE ? (row.namSinh || "") : ""}</span>
      },
      {
        name: "Nữ",
        field: "femaleBirthdate",
        headerStyle: {
          minWidth: "100px"
        },
        render: (row: any) => <span>{row.gender === GENDER_VARIABLE.FEMALE ? (row.namSinh || "") : ""}</span>
      }
    ]
  },
  {
    name: "Khoa, phòng",
    field: "phongBanText",
    headerStyle: {
      minWidth: "100px"
    },
  },
  {
    name: "Tên ngạch, chức danh nghề nghiệp",
    field: "chucDanhText",
    headerStyle: {
      minWidth: "100px"
    },
  },
  {
    name: "Ngạch, bậc, hệ số trước khi nâng bậc",
    field: "",
    child: [
      {
        name: "Mã ngạch, mã số chức danh",
        field: "maChucDanh",
        headerStyle: {
          minWidth: "100px"
        },
      },
      {
        name: "Bậc lương hiện hưởng",
        field: "bacLuongHienHuong",
        headerStyle: {
          minWidth: "100px"
        },
      },
      {
        name: "Hệ số lương hiện hưởng",
        field: "heSoLuongHienHuong",
        headerStyle: {
          minWidth: "100px"
        },
      },
      {
        name: "Thời điểm xếp lương cũ",
        field: "thoiDiemXepLuong",
        headerStyle: {
          minWidth: "100px"
        },
      },
    ]
  },
  {
    name: "Thời gian nâng bậc lương trở lại",
    field: "thoiDiemXepLuongLanSau",
    headerStyle: {
      minWidth: "100px"
    },
  },
  {
    name: "Ghi chú",
    field: "ghiChu",
    headerStyle: {
      minWidth: "100px"
    }
  }
];

export const columnSalaryRaiseTab4: IColumnsGrouping[] = [
  {
    name: "STT",
    field: "stt",
    render: (row, index, stt) => <span>{stt}</span>
  },
  {
    name: "Họ và tên",
    field: "fullName",
    headerStyle: {
      minWidth: "150px"
    },
    cellStyle: {
      textAlign: "left"
    },
  },
  {
    name: "Năm sinh",
    field: "",
    child: [
      {
        name: "Nam",
        field: "maleBirthdate",
        headerStyle: {
          minWidth: "100px"
        },
        render: (row: any) =>  <span>{row.gender === GENDER_VARIABLE.MALE ? (row.namSinh || "") : ""}</span>
      },
      {
        name: "Nữ",
        field: "femaleBirthdate",
        headerStyle: {
          minWidth: "100px"
        },
        render: (row: any) => <span>{row.gender === GENDER_VARIABLE.FEMALE ? (row.namSinh || "") : ""}</span>
      }
    ]
  },
  {
    name: "Khoa, phòng",
    field: "phongBanText",
    headerStyle: {
      minWidth: "100px"
    },
  },
  {
    name: "Tên ngạch, chức danh nghề nghiệp",
    field: "chucDanhText",
    headerStyle: {
      minWidth: "100px"
    },
  },
  {
    name: "Ngạch, bậc, hệ số trước khi nâng bậc",
    field: "",
    child: [
      {
        name: "Mã ngạch, mã số chức danh",
        field: "maChucDanh",
        headerStyle: {
          minWidth: "100px"
        },
      },
      {
        name: "Bậc cuối cùng trong ngạch",
        field: "bacLuongHienHuong",
        headerStyle: {
          minWidth: "100px"
        },
      },
      {
        name: "Hệ số lương của bậc cuối cùng",
        field: "heSoLuongHienHuong",
        headerStyle: {
          minWidth: "100px"
        },
      },
      {
        name: "% phụ cấp TNVK đang hưởng",
        field: "phanTramPhuCapTNVKDangHuong",
        headerStyle: {
          minWidth: "100px"
        },
        render: (row: any) =>  <span>{row.phanTramPhuCapTNVKDangHuong || 0}%</span>
      },
      {
        name: "Thời điểm xếp",
        field: "thoiDiemXepLuong",
        headerStyle: {
          minWidth: "100px"
        },
      },
    ]
  },
  {
    name: "Kết quả nâng  PCTNVK",
    field: "",
    child: [
      {
        name: "% phụ cấp TNVK được hưởng",
        field: "phanTramPhuCapTNVKDuocHuong",
        headerStyle: {
          minWidth: "100px"
        },
        render: (row: any) =>  <span>{row.phanTramPhuCapTNVKDuocHuong || 0}%</span>
      },
      {
        name: "Thời điểm tính hưởng phụ cấp TNVK lần sau",
        field: "thoiDiemXepLuongLanSau",
        headerStyle: {
          minWidth: "100px"
        },
      },
    ]
  },
  {
    name: "Ghi chú",
    field: "ghiChu",
    headerStyle: {
      minWidth: "100px"
    }
  }
];